module.exports = __webpack_public_path__ + "static/media/clock.a6326280.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/SSP/clock.png
// module id = 248
// module chunks = 0